import {
  useGetSignupSessionQuery,
  useUpdateSignupSessionMutation,
} from "@chef/state-management";

export const useSignupSession = () => {
  const { data } = useGetSignupSessionQuery();

  const [updateSignupSession, { isLoading: isSubmitting }] =
    useUpdateSignupSessionMutation();

  return {
    updateSignupSession,
    signupSession: data,
    isUpdatingSignupSession: isSubmitting,
  };
};
